<div *ngIf="!loading; else loadingTemplate">
  <ng-container *ngIf="hasOrderOptions; else noOrderOptions">
    <ngx-datatable
      class="bootstrap"
      rowHeight="auto"
      [cssClasses]="tableCssClasses"
      [rows]="orders"
      [columnMode]="ColumnMode.force"
      [sorts]="[{ prop: columns.orderStatus.prop, dir: 'asc' }]"
      (activate)="onActivate($event)"
    >
      <ngx-datatable-column
        [name]="columns.orderStatus.name | translate"
        [prop]="columns.orderStatus.prop"
        [comparator]="orderStatusComparator"
        [minWidth]="180"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <h6 class="m-0">
            <span
              class="badge badge-pill bg-white border py-1"
              [ngClass]="{
                'border-primary text-primary': !isBookedStatus(row.status),
                'border-success text-success': isBookedStatus(row.status)
              }"
            >
              <i *ngIf="showWarningIcon(row)" class="mdi mdi-alert-circle text-primary"></i>
              {{ row.status }}<span *ngIf="row.optionExpiryDate">, {{ row.displayOptionExpiryDate }}</span>
            </span>
          </h6>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [name]="columns.orderNumber.name | translate" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.orderNumber }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [name]="columns.pnr.name | translate" [sortable]="false" [width]="60" resizeable="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.pnr }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [name]="columns.name.name | translate" prop="mainPassengerName">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.mainPassengerName }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [name]="columns.destination.name | translate" prop="endDestination">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="text-truncate">{{ row.endDestination }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [name]="columns.departureDate.name | translate" [comparator]="departureDateComparator">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          {{ row.displayDepartureDate }}
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ng-container>
</div>

<ng-template #noOrderOptions>
  <div class="text-center py-5">
    <h2>{{ 'OVERVIEW.NO_ORDERS' | translate }}</h2>

    <p>{{ 'OVERVIEW.VISIT_FAREFINDER' | translate }}</p>

    <button appRedirectFarefinder type="button" class="btn btn-primary">
      {{ 'OVERVIEW.TO_FAREFINDER' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <app-loader></app-loader>
</ng-template>
